import Api from "lib/api/httpRequestHelper";

const ENDPOINT = "storeadditionalinfo";

function getValidationMessage(response) {
  return (
    response?.ValidationMessage ??
    response?.validationMessage ??
    "Não foi possível processar a solicitação."
  );
}

function assertSuccess(response) {
  if (response?.Success === false) {
    throw new Error(getValidationMessage(response));
  }
  return response?.Result ?? null;
}

export async function getStoreNotificationEmail(idLoja) {
  const response = await Api.get(
    "store-notification-email",
    ENDPOINT,
    `?idLoja=${idLoja}`,
    true,
  );
  return assertSuccess(response);
}

export async function updateStoreNotificationEmail(idLoja, emailNotificacaoBoleto) {
  const emailParam = encodeURIComponent(emailNotificacaoBoleto ?? "");
  const response = await Api.postParams(
    "update-store-notification-email",
    ENDPOINT,
    `?idLoja=${idLoja}&emailNotificacaoBoleto=${emailParam}`,
    true,
  );
  return assertSuccess(response);
}

export const ORIGEM_EMAIL_LABEL = {
  Principal: "E-mail Contato",
  Alternativo: "E-mail Alternativo",
  NFe: "E-mail NFe",
};

export function getEmailOrigemLabel(origem) {
  return ORIGEM_EMAIL_LABEL[origem] || origem || "E-mail";
}
